import { BalanceType } from '@profile/src/models';
export const options = [{
  label: 'Claim',
  id: BalanceType.CLAIM.toString()
}, {
  label: 'Deposit',
  id: BalanceType.DEPOSIT.toString()
}, {
  label: 'Upgrade Hero',
  id: BalanceType.UPGRADE_HERO.toString()
}, {
  label: 'Battle End',
  id: BalanceType.BATTLE_END.toString()
}, {
  label: 'Level Up',
  id: BalanceType.LEVEL_UP.toString()
}, {
  label: 'Ranking Reward',
  id: BalanceType.RANKING_REWARD.toString()
}, {
  label: 'Season Box Reward',
  id: BalanceType.SEASON_BOX_REWARD.toString()
}, {
  label: 'Shop PowerPoint',
  id: BalanceType.SHOP_POWER_POINT.toString()
}, {
  label: 'Referral Reward',
  id: BalanceType.REFERRAL_REWARD.toString()
}, {
  label: 'Referral Reward (MKP)',
  id: BalanceType.REFERRAL_REWARD_MKP.toString()
}, {
  label: 'Non-NFT Box',
  id: BalanceType.SHOP_BOX_NON_NFT.toString()
}, {
  label: 'Join Special Event',
  id: BalanceType.SPECIAL_EVENT_FEE_JOIN.toString()
}, {
  label: 'Buy Skill Turn',
  id: BalanceType.BUY_SKILL_TURN.toString()
}, {
  label: 'Play Again Bonus',
  id: BalanceType.PLAY_AGAIN_BONUS.toString()
}, {
  label: 'Claim Fee',
  id: BalanceType.CLAIM_FEE.toString()
}, {
  label: 'Claim Refund',
  id: BalanceType.CLAIM_REFUND.toString()
}, {
  label: 'Mythical Christmas Box',
  id: BalanceType.MYTHICAL_CHRISTMAS_BOX.toString()
}, {
  label: 'Vesting Safe',
  id: BalanceType.VESTING_CLAIM.toString()
}, {
  label: 'Convert Vesting',
  id: BalanceType.CONVERT_VESTING.toString()
}, {
  label: 'Admin Revert',
  id: BalanceType.ADMIN_REVERT.toString()
}, {
  label: 'Creator Program Viewer',
  id: BalanceType.CREATOR_PROGRAM_VIEWER.toString()
}, {
  label: 'Staking Claim',
  id: BalanceType.STAKING_REWARD.toString()
}, {
  label: 'Buy Private Sale',
  id: BalanceType.BUY_PRIVATE_SALE.toString()
}, {
  label: 'Refund Private Sale',
  id: BalanceType.REFUND_PRIVATE_SALE.toString()
}, {
  label: 'Fusion Refresh Fee',
  id: BalanceType.FUSION_REFRESH_OUTPUT.toString()
}, {
  label: 'Daily Quest',
  id: BalanceType.DAILY_QUEST.toString()
}, {
  label: 'Change Username',
  id: BalanceType.CHANGE_NAME_PROFILE.toString()
}, {
  label: 'Quest',
  id: BalanceType.MKP_QUEST_STAGE_REWARD.toString()
}, {
  label: 'Daily Free',
  id: BalanceType.MKP_QUEST_DAILY_CHECKIN.toString()
}, {
  label: 'Daily Quest Login',
  id: BalanceType.MKP_QUEST_DAILY_STREAK.toString()
}, {
  label: 'Competition Reward',
  id: BalanceType.MKP_QUEST_LB_REWARD.toString()
}, {
  label: 'Quest Box',
  id: BalanceType.MKP_QUEST_BOX_BUY.toString()
}, {
  label: 'Daily Quest Box',
  id: BalanceType.MKP_QUEST_BOX_OPEN.toString()
}, {
  label: 'Daily Quest Refresh',
  id: BalanceType.MKP_QUEST_REFRESH.toString()
}, {
  label: 'Trading Event',
  id: BalanceType.TRADING_EVENT_DAILY.toString()
}, {
  label: 'Refresh Daily Trading',
  id: BalanceType.TRADING_REFRESH_DAILY.toString()
}, {
  label: 'Giftmas Fortune Wheel',
  id: BalanceType.WHEEL_REWARD.toString()
}];